module.exports = __webpack_public_path__ + "img/image152.8061bb77.jpg";